import { Warning } from '@gyym/ui/icons'
import React from 'react'

import { Container, Text } from './styles'

export interface NotificationProps {
  count: number
}

export const Notification = ({ count }: NotificationProps) => {
  return (
    <Container href="/notifications">
      <Warning width="24px" height="24px" />
      <Text>新着のお知らせが{count}件あります</Text>
    </Container>
  )
}
